module.exports = __webpack_public_path__ + "img/logo_text_blu.cebaa7c4.svg";